import { TimeCreditActivity, LifePointActivity, User } from '@types';

import axiosBaseApi from '../axiosBaseApi';

/**
 * Retrieves user information.
 */
export const getUserInfo = async (): Promise<{ user: User } | undefined> => {
	try {
		return await axiosBaseApi.get(`/users/me`);
	} catch (error) {
		console.error('Error get user info:', error);
	}
};

export const getUserTimeCreditActivities = async (
	page: number | undefined,
	limit: number | undefined
): Promise<{ time_credit_activities: Array<TimeCreditActivity> } | undefined> => {
	try {
		const params = {};
		if (page) {
			params['page'] = page;
		}
		if (limit) {
			params['limit'] = limit;
		}
		const query = new URLSearchParams(params).toString();

		return await axiosBaseApi.get(`/users/me/time_credit_activities?${query}`);
	} catch (error) {
		console.error('Error get user time credit activities:', error);
	}
};

export const getUserLifePointActivities = async (
	page: number | undefined,
	limit: number | undefined
): Promise<{ life_point_activities: Array<LifePointActivity> } | undefined> => {
	try {
		const params = {};
		if (page) {
			params['page'] = page;
		}
		if (limit) {
			params['limit'] = limit;
		}
		const query = new URLSearchParams(params).toString();

		return await axiosBaseApi.get(`/users/me/life_point_activities?${query}`);
	} catch (error) {
		console.error('Error get user life point activities:', error);
	}
};

export const getUserGamePasses = async () => {
	try {
		return await axiosBaseApi.get(`/users/me/game_pass_nfts`);
	} catch (error) {
		console.error('Error get user game passes:', error);
	}
};

export const getUserTimeCreditLifePointActivities = async (
	page: number | undefined,
	limit: number | undefined
): Promise<{ time_credit_activities: Array<TimeCreditActivity> } | undefined> => {
	try {
		const params = {};
		if (page) {
			params['page'] = page;
		}
		if (limit) {
			params['limit'] = limit;
		}
		const query = new URLSearchParams(params).toString();

		return await axiosBaseApi.get(`/users/me/tc_lp_activities?${query}`);
	} catch (error) {
		console.error('Error get user time credit activities:', error);
	}
};
